export default __webpack_public_path__ + "7a06438b766690498ff7244b8fd3fb8e.png";